export default {
  "content": "_content_rz8bm_1",
  "content--variant-elevated": "_content--variant-elevated_rz8bm_1",
  "content--elevation-raised": "_content--elevation-raised_rz8bm_1",
  "content--radius-small": "_content--radius-small_rz8bm_1",
  "content--has-width": "_content--has-width_rz8bm_1"
};import "ni:sha-256;YTzpNKw500C7E8qadkbQIk2tHEE2scCbVG-408f8hdw";